import { useState } from "react";
import { CheckIcon, CopyIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

// A copyable shell command row. Shared by the install card and the submit hint.
export function CopyCommand({ cmd }: { cmd: string }) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard?.writeText(cmd).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      },
      () => {}
    );
  };

  return (
    <div className="flex items-center justify-between gap-3 rounded-md border bg-background px-3 py-2 font-mono text-sm">
      <code className="min-w-0 truncate">{cmd}</code>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 shrink-0 gap-1.5 text-xs"
        onClick={copy}
      >
        {copied ? (
          <>
            <CheckIcon className="size-3.5" />
            Copied
          </>
        ) : (
          <>
            <CopyIcon className="size-3.5" />
            Copy
          </>
        )}
      </Button>
    </div>
  );
}
